import { LayoutNavigationExtra, LayoutRoute } from 'src/app/_core/services/layout.service';
import { MenuInterface } from 'src/app/_core/components/layout-nav/routes';
import {
    activitySettingsStatusRoutes
} from 'src/app/board/activity/activity-shared/activity-settings/activity-settings-status/activity-settings-status-routes';
import { Logger } from 'src/app/_core/tools/logger';
import {
    activitySettingsFormsRoutes
} from 'src/app/board/activity/activity-shared/activity-settings/activity-settings-forms/activity-settings-forms-routes';
import { RouteActivityType } from 'src/app/board/activity/activity.constants';
import {
    activitySettingsRoutes
} from 'src/app/board/activity/activity-shared/activity-settings/activity-settings-route';
import {
    activityCatalogRoutes
} from 'src/app/board/activity/activity-shared/activity-settings/activity-catalog/activity-catalog-routes';
import {
    activityMediaCatalogRoutes
} from 'src/app/board/activity/activity-shared/activity-settings/activity-media-catalog/activity-media-catalog-routes';
import { activityPrintsRoutes } from 'src/app/board/activity/activity-shared/activity-prints/activity-prints-routes';
import { activityBeneficiariesOrdersRoutes } from 'src/app/board/activity/activity-shared/activity-beneficiaries-orders/activity-beneficiaries-orders-routes';
import { activityBeneficiariesInvoicesRoutes } from 'src/app/board/activity/activity-shared/activity-beneficiaries-invoices/activity-beneficiaries-invoices-routes';
import { activityBeneficiariesDeliveriesRoutes } from 'src/app/board/activity/activity-shared/activity-beneficiaries-deliveries/activity-beneficiaries-deliveries-routes';
import { activitySuppliersOrdersRoutes } from 'src/app/board/activity/activity-shared/activity-suppliers-orders/activity-suppliers-orders-routes';
import { activitySuppliersInvoicesRoutes } from 'src/app/board/activity/activity-shared/activity-suppliers-invoices/activity-suppliers-invoices-routes';
import { activityFreeEntriesRoutes } from 'src/app/board/activity/activity-shared/activity-free-entries/activity-free-entries-routes';
import { activityBookingsRoutes } from 'src/app/board/activity/activity-shared/activity-bookings/activity-bookings-routes';
import { activitySettingsFormFieldRoutes } from 'src/app/board/activity/activity-shared/activity-settings/activity-settings-form-field/activity-settings-form-field-routes';
import {
    activityActivitiesSettingsRoutes
} from 'src/app/board/activity/activity-shared/activity-generals-settings/activity-activities-settings/activity-activities-settings.routes';
import { activityStocksRoutes } from 'src/app/board/activity/activity-shared/activity-stocks/activity-stocks-routes';

export const activitySharedRoutes: MenuInterface[] = [
    ...activitySettingsRoutes,
    ...activityStocksRoutes,
    ...activityCatalogRoutes,
    ...activityMediaCatalogRoutes,
    ...activityPrintsRoutes,
    ...activityBeneficiariesOrdersRoutes,
    ...activityBeneficiariesInvoicesRoutes,
    ...activityBeneficiariesDeliveriesRoutes,
    ...activitySuppliersOrdersRoutes,
    ...activitySuppliersInvoicesRoutes,
    ...activityFreeEntriesRoutes,
    ...activitySettingsStatusRoutes,
    ...activityBookingsRoutes,
    ...activitySettingsFormFieldRoutes,
    ...activitySettingsFormsRoutes,
    ...activityActivitiesSettingsRoutes,
];

export function getRouteByActivityType(routeName: string, activityType: RouteActivityType): [LayoutRoute, LayoutNavigationExtra] {
    const logger = new Logger('route construction log');
    const selectedRoute = activitySharedRoutes.find(e => e.code === routeName)?.route || [];
    const formattedRoute: LayoutRoute = {};
    try {
        Object.keys(selectedRoute[0])?.forEach(key => {
            const hasActivity = selectedRoute[0][key].startsWith('activity/');
            const hasType = selectedRoute[0][key].startsWith('$type');
            formattedRoute[key] = ((hasActivity || !hasType) ? '' : 'activity/') + selectedRoute[0][key].replace('$type', activityType);
        });
    } catch (e) {
        logger.error('Pas de route trouvé pour ' + routeName + ' pour le type d\'activité ' + activityType);
    }


    return [formattedRoute, selectedRoute[1]];
}
